import React, { useRef, useState } from "react";
import cn from "classnames";
import { uploadCampaignAsset } from "../../../api/campaigns.service";
import styles from "./ImageDropField.module.sass";

/**
 * Campo de imagen con drag & drop: suelta un fichero (o haz clic en «Subir») y se
 * sube a /messaging/assets; también acepta pegar una URL a mano.
 */
const ImageDropField = ({ value, onChange, disabled, onNotify }) => {
  const [over, setOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const upload = async (file) => {
    if (!file || !file.type.startsWith("image/")) return;
    setUploading(true);
    try {
      const resp = await uploadCampaignAsset(file);
      if (resp?.url) onChange(resp.url);
      else throw new Error("no url");
    } catch (e) {
      onNotify?.({ severity: "error", msg: "No se pudo subir la imagen" });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      className={cn(styles.field, { [styles.over]: over, [styles.disabled]: disabled })}
      onDragOver={(e) => {
        if (!disabled && e.dataTransfer?.types?.includes("Files")) {
          e.preventDefault();
          setOver(true);
        }
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        if (disabled) return;
        e.preventDefault();
        setOver(false);
        upload(e.dataTransfer?.files?.[0]);
      }}
    >
      {value ? (
        <img
          className={styles.thumb}
          src={value}
          alt=""
          onError={(e) => (e.target.style.visibility = "hidden")}
        />
      ) : (
        <div className={styles.thumbEmpty}>🖼</div>
      )}
      <input
        className={styles.input}
        placeholder={over ? "Suelta la imagen…" : "Arrastra una imagen, sube o pega URL"}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      {!disabled && (
        <button
          type="button"
          className={styles.uploadButton}
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? "Subiendo…" : "Subir"}
        </button>
      )}
      {value && !disabled && (
        <button type="button" className={styles.clear} title="Quitar" onClick={() => onChange("")}>
          ✕
        </button>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          upload(e.target.files?.[0]);
          e.target.value = "";
        }}
      />
    </div>
  );
};

export default ImageDropField;
